import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';

const News = () => {
  const news = [
    {
      date: 'January 2025',
      title: 'Record Migration Season',
      excerpt: 'The 2024-2025 Great Migration has been exceptional, with record numbers of wildebeest and zebra crossing the Mara River. Our balloon flights have provided guests with unprecedented views of this natural spectacle.',
      image: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=800'
    },
    {
      date: 'December 2024',
      title: 'Safety Excellence Award',
      excerpt: 'SKYHIGH Adventures has been honored with the Kenya Tourism Board\'s Safety Excellence Award, recognizing our 48-year perfect safety record and commitment to the highest standards of aviation safety.',
      image: 'https://images.unsplash.com/photo-1489392191049-fc10c97e64b6?w=800'
    },
    {
      date: 'November 2024',
      title: 'New Balloon Added to Fleet',
      excerpt: 'We\'re excited to announce the addition of a new state-of-the-art balloon to our fleet, manufactured in Britain to the highest standards. This brings our total fleet to five balloons, allowing us to accommodate more guests.',
      image: 'https://images.unsplash.com/photo-1761976671459-8a27e6b78c09?w=800'
    },
    {
      date: 'October 2024',
      title: 'Partnership with Conservation',
      excerpt: 'SKYHIGH Adventures announces new partnership with Mara Conservancy to support wildlife conservation efforts. A portion of every flight now directly contributes to protecting Uganda ecosystem.',
      image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800'
    },
    {
      date: 'September 2024',
      title: 'Peak Season Success',
      excerpt: 'The 2024 peak season has been our busiest ever, with guests from over 40 countries experiencing the magic of Uganda from above. Thank you to everyone who chose SKYHIGH Adventures for their safari.',
      image: 'https://images.unsplash.com/photo-1723270868972-fed4b06feae4?w=800'
    },
    {
      date: 'August 2024',
      title: 'Celebrating 48 Years',
      excerpt: 'This month marks 48 years since our first flight over Uganda in 1976. We\'re proud to continue the legacy of Alan Root and remain the pioneers of hot air ballooning in Kenya.',
      image: 'https://images.unsplash.com/photo-1516886635086-2b3c423c0947?w=800'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(101, 67, 33, 0.5)' }}></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">News & Updates</h1>
          <p className="text-xl">Latest from SKYHIGH Adventures</p>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {news.map((item, index) => (
              <article key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all group border border-stone-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <div className="flex items-center mb-3" style={{ color: '#EE6A1F' }}>
                    <Calendar className="w-5 h-5 mr-2" />
                    <span className="text-sm font-semibold">{item.date}</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-[#EE6A1F] transition-colors">{item.title}</h2>
                  <p className="text-gray-600 leading-relaxed mb-4">{item.excerpt}</p>
                  <button className="flex items-center font-semibold transition-colors group" style={{ color: '#EE6A1F' }}>
                    Read More
                    <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 px-4 bg-stone-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Stay Connected</h2>
          <p className="text-lg text-gray-600 mb-8">
            Subscribe to receive the latest news, special offers, and updates about balloon safaris in Uganda.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-xl mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-6 py-3 rounded-lg border-2 border-stone-300 focus:border-[#EE6A1F] focus:outline-none"
            />
            <button 
              className="text-white font-semibold px-8 py-3 rounded-lg transition-all hover:opacity-90"
              style={{ backgroundColor: '#EE6A1F' }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;
